import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Spinner } from 'react-bootstrap';
import { useAuth } from 'context/AuthContext';

const SupportSessionBanner = () => {
  const { t } = useTranslation();
  const { getActiveSupportSession, exitSupportSession } = useAuth();
  const navigate = useNavigate();
  const [exiting, setExiting] = useState(false);

  const session = getActiveSupportSession();
  if (!session) return null;

  const handleExit = async () => {
    setExiting(true);
    try {
      await exitSupportSession();
      navigate('/support');
    } finally {
      setExiting(false);
    }
  };

  return (
    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1050,
        background: '#b45309',
        color: '#fff',
        padding: '8px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: '0.85rem',
        boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
      }}
    >
      <span>
        <FontAwesomeIcon icon="headset" className="me-2" />
        <strong>{t('SUPPORT.MASQUERADE_BANNER')}: </strong>
        {session.company_name}
        {session.session_type === 'setup_admin' && (
          <span
            style={{
              marginLeft: 8,
              background: '#fbbf24',
              color: '#78350f',
              borderRadius: 4,
              padding: '1px 6px',
              fontSize: '0.75rem',
              fontWeight: 700,
            }}
          >
            {t('SUPPORT.SESSION_TYPE.ADMIN')}
          </span>
        )}
      </span>
      <button
        onClick={handleExit}
        disabled={exiting}
        style={{
          background: 'rgba(255,255,255,0.15)',
          border: '1px solid rgba(255,255,255,0.4)',
          color: '#fff',
          borderRadius: 4,
          padding: '3px 10px',
          cursor: 'pointer',
          fontSize: '0.8rem',
          display: 'flex',
          alignItems: 'center',
          gap: 6,
        }}
      >
        {exiting ? (
          <Spinner size="sm" animation="border" />
        ) : (
          <>
            <FontAwesomeIcon icon="sign-out-alt" />
            {t('SUPPORT.EXIT_MASQUERADE')}
          </>
        )}
      </button>
    </div>
  );
};

export default SupportSessionBanner;
